import { Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'

const SupplyBillAgreeCount = ({ items, type, title, ico }) => {

    const [countAgree, setCountAgree] = useState(0)
    const [countDisagree, setCountDisagree] = useState(0)
    const [countOther, setCountOther] = useState(0)

    useEffect(() => {
        changeCount()
    }, [items])

    const changeCount = () => {
        if (items && items.length > 0) {
            let countAgreeTemp = 0, countDisagreeTemp = 0, countOtherTemp = 0
            for (const item of items) {
                if (item[type] === true) {
                    countAgreeTemp += 1
                } else if (item[type] === false) {
                    countDisagreeTemp += 1
                } else {
                    countOtherTemp += 1
                }
            }

            setCountAgree(countAgreeTemp)
            setCountDisagree(countDisagreeTemp)
            setCountOther(countOtherTemp)
        } else {
            setCountAgree(0)
            setCountDisagree(0)
            setCountOther(0)
        }
    }

  return (
    // <p className={`supplyAgrees__agree `}>
    <div className={`commentShortOne`}>
        <Tooltip title={`${title} (+ / - / ?)`}>
            {ico}
        </Tooltip>
        <p>
            <span className='green'>{countAgree}</span>
            <span> / </span>
            <span className='red'>{countDisagree}</span>
            <span> / </span>
            <span>{countOther}</span>
        </p>
    </div>
  )
}

export default SupplyBillAgreeCount